import { render, staticRenderFns } from "./FloodReinstatement.vue?vue&type=template&id=54ac2546"
import script from "./FloodReinstatement.vue?vue&type=script&lang=js"
export * from "./FloodReinstatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports